"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimatedHackerGridItem = void 0;
const react_1 = __importDefault(require("react"));
const animation_1 = require("../../utils/animation");
const constants_1 = require("./constants");
const AnimatedHackerGridItem = ({ children, onClick, layoutId, }) => {
    return (react_1.default.createElement(animation_1.MotionGridItem, { variants: constants_1.ANIMATED_HACKER_GRID_ANIMATION_VARIANTS, layoutId: layoutId, cursor: onClick ? 'pointer' : undefined, onClick: onClick }, children));
};
exports.AnimatedHackerGridItem = AnimatedHackerGridItem;
//# sourceMappingURL=AnimatedHackerGridItem.js.map